import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	x: 0,
	y: 0,
	viewBox: "0 0 45 45",
	xmlSpace: "preserve",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			y: .1,
			className: "icon-fill-primary",
			width: 45,
			height: 2.5
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-secondary",
			d: "M22.5 36.4c-.7 0-1.2-.6-1.2-1.2V7.3c0-.7.6-1.2 1.2-1.2s1.2.6 1.2 1.2v27.8c.1.8-.5 1.3-1.2 1.3z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-secondary",
			d: "M13.1 25.1c-.7 0-1.2-.6-1.2-1.2V7.3c0-.7.6-1.2 1.2-1.2s1.2.6 1.2 1.2v16.5c.1.7-.5 1.3-1.2 1.3z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-secondary",
			d: "M4.2 18.2c-.7 0-1.2-.5-1.2-1.2V7.3c0-.7.6-1.2 1.2-1.2s1.2.6 1.2 1.2V17c.1.7-.5 1.2-1.2 1.2z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-secondary",
			d: "M31.9 25.1c-.7 0-1.2-.6-1.2-1.2V7.3c0-.7.6-1.2 1.2-1.2s1.2.6 1.2 1.2v16.5c0 .7-.5 1.3-1.2 1.3z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-secondary",
			d: "M40.8 18.2c-.7 0-1.2-.6-1.2-1.2V7.3c0-.7.6-1.2 1.2-1.2s1.2.5 1.2 1.2V17c0 .7-.5 1.2-1.2 1.2z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-primary",
			d: "M22.5 45c-6.4 0-9.4-5.4-12.3-10.6C7.5 29.5 4.9 25 0 25v-2.5c6.4 0 9.4 5.4 12.3 10.6 2.7 4.8 5.3 9.4 10.2 9.4 4.9 0 7.5-4.5 10.2-9.4 2.9-5.2 6-10.6 12.3-10.6V25c-4.9 0-7.5 4.5-10.2 9.4C31.9 39.6 28.9 45 22.5 45z"
		})
	]
});
export default SvgIcon;
